/**
 * @generated SignedSource<<83b58b2ef5e656efe88cce02d8afac05>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type seriesBannerContent$data = {
  readonly publishedDate: number | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"entityLink" | "hooksContentItemProvidersContent" | "hooksSeriesArticleSectionTagArticle" | "shareArticle20Content">;
  readonly " $fragmentType": "seriesBannerContent";
};
export type seriesBannerContent$key = {
  readonly " $data"?: seriesBannerContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"seriesBannerContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "seriesBannerContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "hooksSeriesArticleSectionTagArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "withCoverImage",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "withCoverImageLandscape250x99",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "withCoverImageSize540x360",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "withHeadline",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "withSummary",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "withUpdatedDate",
          "value": true
        }
      ],
      "kind": "FragmentSpread",
      "name": "hooksContentItemProvidersContent"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishedDate",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "shareArticle20Content"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "2da8224c3ea310d121c1fab3fccc1ff4";

export default node;
